class SearchModal {
  constructor() {
    this.searchModalState();
  }

  searchModalState() {
    const modalTrigger = document.querySelector('.search--trigger');
    const searchModalOverlay = document.querySelector('.modal-overlay');

    const modalElements = [];
    const searchModal = document.getElementById('search-modal');
    const body = document.body;

    if (!modalTrigger || !searchModal) {
      return;
    }

    if (searchModal && body) {
      modalElements.push(searchModal, body);
    }

    modalTrigger.addEventListener('click', (event) => {
      modalElements.forEach((element) => {
        element.classList.toggle("modal--active");
      });
    });

    searchModalOverlay.addEventListener('click', (event) => {
      modalElements.forEach((element) => {
        element.classList.toggle("modal--active");
      });
    });
    
  }
}

export default SearchModal;